import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Consegna } from "@/types/api";

export function useConsegnaProssima() {
  return useQuery({
    queryKey: ["consegna-prossima"],
    // 204 No Content → apiFetch ritorna `null`: la roadmap non ha più nulla in
    // programma, e la casella lo dice invece di inventare una data.
    queryFn: () => apiFetch<Consegna | null>("/api/v1/consegne/prossima"),
    staleTime: 60_000,
  });
}
